// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Sidebar from '../Core/Sidebar';
// import Navbar from '../Core/Navbar';
// import { Search, User, CheckCircle, Wallet, Send, Copy, ArrowLeft, Shield, Zap, DollarSign } from 'lucide-react';
// import '../../Dashboard Style/WalletTransfer.css';
// import { useSelector } from 'react-redux';

// const WalletTransfer = () => {
//   const navigate = useNavigate();
//   const [activeMode, setActiveMode] = useState('active-id'); // 'active-id' or 'send-money'
//   const [availableAmount] = useState(1500.75); // Main wallet amount
//   const [activeEmail, setActiveEmail] = useState('');
//   const [sendEmail, setSendEmail] = useState('');
//   const [customAmount, setCustomAmount] = useState('');
//   const [searching, setSearching] = useState(false);
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [searchResult, setSearchResult] = useState(null);
//   const [accountName, setAccountName] = useState('');
//   const [apiError, setApiError] = useState('');
//   const [transferring, setTransferring] = useState(false);
//   const authToken = useSelector((state) => state.user?.token);

//   // Add openDropdowns state
//   const [openDropdowns, setOpenDropdowns] = useState({});

//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   // Initialize sidebar functionality (same as in Dashboard)
//   useEffect(() => {
//     const sidebar = document.querySelector('.sidebar');
//     const sidebarBody = document.querySelector('.sidebar-body');
    
//     if (sidebar) {
//       if (sidebarOpen) {
//         sidebar.classList.remove('close');
//       } else {
//         sidebar.classList.add('close');
//       }
//     }
    
//     // Add custom scrollbar to sidebar body
//     if (sidebarBody) {
//       sidebarBody.style.height = 'calc(100vh - 70px)';
//       sidebarBody.style.overflowY = 'auto';
//     }

//     // Initialize dropdowns as closed
//     const initialDropdownState = {
//       dashboard: false,
//       fundManagement: false,
//       registrationTeam: false,
//       incomeEarnings: false,
//       bonanzaRewards: false,
//       airdrop: false,
//       withdrawal: false,
//       settings: false
//     };
//     setOpenDropdowns(initialDropdownState);

//     return () => {
//       // Cleanup
//     };
//   }, [sidebarOpen]);

//   useEffect(() => {
//     // Add custom scrollbar styles for sidebar
//     const style = document.createElement('style');
//     style.innerHTML = `
//       /* Custom scrollbar for sidebar */
//       .sidebar-body {
//         height: calc(100vh - 70px);
//         overflow-y: auto;
//       }
      
//       .sidebar-body::-webkit-scrollbar {
//         width: 6px;
//       }
      
//       .sidebar-body::-webkit-scrollbar-track {
//         background: rgba(255, 255, 255, 0.05);
//         border-radius: 10px;
//       }
      
//       .sidebar-body::-webkit-scrollbar-thumb {
//         background: rgba(255, 255, 255, 0.2);
//         border-radius: 10px;
//       }
      
//       .sidebar-body::-webkit-scrollbar-thumb:hover {
//         background: rgba(255, 255, 255, 0.3);
//       }
      
//       /* Sidebar dropdown menu styles */
//       .sidebar .nav-dropdown {
//         list-style: none;
//         padding-left: 0;
//         max-height: 0;
//         overflow: hidden;
//         transition: max-height 0.3s ease;
//       }
      
//       .sidebar .nav-dropdown.show {
//         max-height: 500px;
//       }
      
//       .sidebar .nav-dropdown-item {
//         padding-left: 2.5rem;
//       }
      
//       /* Sidebar dropdown toggle with icon */
//       .nav-item.has-dropdown .nav-link {
//         position: relative;
//         padding-right: 2.5rem;
//       }
      
//       .nav-item.has-dropdown .dropdown-icon {
//         position: absolute;
//         right: 1rem;
//         top: 50%;
//         transform: translateY(-50%);
//         transition: transform 0.3s ease;
//       }
      
//       .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
//         transform: translateY(-50%) rotate(180deg);
//       }
      
//       /* Improved dropdown styling similar to first image */
//       .nav-item.has-dropdown .nav-dropdown {
//         background: rgba(255, 255, 255, 0.05);
//         border-left: 3px solid var(--primary-color, #0d6efd);
//         margin-left: 1rem;
//         border-radius: 0 0 8px 8px;
//       }
      
//       .nav-item.has-dropdown .nav-dropdown-item .nav-link {
//         padding: 0.75rem 1rem 0.75rem 2rem;
//         color: rgba(255, 255, 255, 0.8);
//       }
      
//       .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
//         background: rgba(255, 255, 255, 0.1);
//         color: white;
//       }
      
//       /* Fix for category text styling */
//       .nav-item.has-dropdown .link-title.nav-item.nav-category {
//         font-weight: 600;
//         font-size: 0.875rem;
//         text-transform: uppercase;
//         letter-spacing: 0.5px;
//       }
      
//       /* Smooth transitions */
//       .sidebar {
//         transition: all 0.3s ease;
//       }
//     `;
//     document.head.appendChild(style);

//     return () => {
//       document.head.removeChild(style);
//     };
//   }, []);

//   // Toggle dropdown function (for the Sidebar component)
//   const toggleDropdown = (key) => {
//     setOpenDropdowns((prev) => ({
//       ...prev,
//       [key]: !prev[key],
//     }));
//   };

//   // API call to search user by email
//   const searchUserByEmail = async (email) => {
//     try {
//       setSearching(true);
//       setApiError('');
      
//       const response = await fetch(`https://admin.oceaniabloom9.com/api/user/get-user-by-email`, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${authToken}`,
//           'Accept': 'application/json',
//         },
//         body: new URLSearchParams({
//           email: email
//         })
//       });

//       const data = await response.json();
      
//       if (data.status) {
//         // User found successfully
//         setAccountName(data.data.account_name || 'User Found');
//         setSearchResult({
//           email: email,
//           name: data.data.account_name || email,
//           avatarColor: '#00d4aa',
//           verified: true
//         });
//         return { success: true, data: data.data };
//       } else {
//         // User not found or error
//         setSearchResult(null);
//         setAccountName('');
//         setApiError(data.message || 'User not found');
//         return { success: false, message: data.message };
//       }
//     } catch (error) {
//       console.error('Error searching user:', error);
//       setSearchResult(null);
//       setAccountName('');
//       setApiError('Failed to search user. Please try again.');
//       return { success: false, message: 'Network error' };
//     } finally {
//       setSearching(false);
//     }
//   };

//   const handleSearchActiveEmail = async () => {
//     if (!activeEmail.trim()) {
//       alert('Please enter an email address');
//       return;
//     }
    
//     await searchUserByEmail(activeEmail);
//   };

//   const handleSearchSendEmail = async () => {
//     if (!sendEmail.trim()) {
//       alert('Please enter an email address');
//       return;
//     }
    
//     await searchUserByEmail(sendEmail);
//   };

//   // API call for Active ID transfer ($5)
//   const handleActiveIdTransfer = async () => {
//     try {
//       setTransferring(true);
      
//       const response = await fetch(`https://admin.oceaniabloom9.com/api/user/active-register-user-by-wallet`, {
//         method: 'POST',
//          headers: {
//           'Authorization': `Bearer ${authToken}`,
//           'Accept': 'application/json',
//         },
//         body: new URLSearchParams({
//           email: activeEmail
//         })
//       });

//       const data = await response.json();
      
//       if (data.status) {
//         alert('User activated successfully! $5 transferred.');
//         navigate('/dashboard');
//       } else {
//         alert(data.message || 'Transfer failed');
//       }
//     } catch (error) {
//       console.error('Error activating user:', error);
//       alert('Failed to activate user. Please try again.');
//     } finally {
//       setTransferring(false);
//     }
//   };

//   // API call for Send Money transfer (custom amount)
//   const handleSendMoneyTransfer = async () => {
//     try {
//       setTransferring(true);
      
//       const response = await fetch(`https://admin.oceaniabloom9.com/api/user/sent-wallet`, {
//         method: 'POST',
//          headers: {
//           'Authorization': `Bearer ${authToken}`,
//           'Accept': 'application/json',
//         },
//         body: new URLSearchParams({
//           email: sendEmail,
//           wallet_type: 'FuelWallet', // Adjust this based on your requirements
//           amount: customAmount
//         })
//       });

//       const data = await response.json();
      
//       if (data.status) {
//         alert(`$${customAmount} sent successfully!`);
//         navigate('/dashboard');
//       } else {
//         alert(data.message || 'Transfer failed');
//       }
//     } catch (error) {
//       console.error('Error sending money:', error);
//       alert('Failed to send money. Please try again.');
//     } finally {
//       setTransferring(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (activeMode === 'active-id') {
//       if (!activeEmail.trim()) {
//         alert('Please enter recipient email');
//         return;
//       }
      
//       if (!searchResult) {
//         alert('Please search and verify the user first');
//         return;
//       }
      
//       if (window.confirm(`Send $5.00 to ${activeEmail}?`)) {
//         await handleActiveIdTransfer();
//       }
//     } else {
//       if (!sendEmail.trim() || !customAmount) {
//         alert('Please fill all fields');
//         return;
//       }
      
//       if (!searchResult) {
//         alert('Please search and verify the user first');
//         return;
//       }
      
//       const amount = parseFloat(customAmount);
//       if (amount > availableAmount) {
//         alert('Insufficient funds in your wallet');
//         return;
//       }
      
//       if (amount < 1) {
//         alert('Minimum transfer amount is $1');
//         return;
//       }
      
//       if (window.confirm(`Send $${amount.toFixed(2)} to ${sendEmail}?`)) {
//         await handleSendMoneyTransfer();
//       }
//     }
//   };

//   const handleCopyEmail = () => {
//     const email = activeMode === 'active-id' ? activeEmail : sendEmail;
//     if (email) {
//       navigator.clipboard.writeText(email);
//       alert('Email copied to clipboard!');
//     }
//   };

//   // Reset search when switching modes
//   const handleModeChange = (mode) => {
//     setActiveMode(mode);
//     setSearchResult(null);
//     setAccountName('');
//     setApiError('');
//     if (mode === 'active-id') {
//       setSendEmail('');
//     } else {
//       setActiveEmail('');
//     }
//   };

//   return (
//     <div className="main-wrapper dark-theme">
//       {/* Sidebar */}
//       <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
//         <div className="sidebar-header">
//           <a href="#" className="sidebar-brand">
//             <i className="me-2" data-lucide="atom"></i>
//             Willow <span>Quantum</span>
//           </a>
//           <div className="sidebar-toggler" onClick={toggleSidebar}>
//             <span></span>
//             <span></span>
//             <span></span>
//           </div>
//         </div>
//         <Sidebar />
//       </nav>

//       <div className="page-wrapper">
//         {/* Navbar */}
//         <Navbar toggleSidebar={toggleSidebar} />

//         {/* Main Content */}
//         <div className="page-content">
//           <div className="wallet-transfer-container-dark">
//             <div className="container-fluid">
//               <div className="row justify-content-center">
//                 <div className="" style={{width:"100%"}}>
//                   {/* Main Card */}
//                   <div className="dark-transfer-card">
                 
//                     <div className="dark-balance-section">
//                       <div className="balance-card-dark">
//                         <div className="balance-content">
//                           <div className="balance-label-dark">My Wallet Balance</div>
//                           <div className="balance-amount-dark">${availableAmount.toFixed(2)}</div>
//                           <div className="balance-subtitle-dark">Quantum Main Vault • Ready to Transfer</div>
//                         </div>
//                         <div className="wallet-icon-dark">
//                           <Wallet size={40} />
//                         </div>
//                       </div>
//                     </div>

//                     {/* Mode Toggle */}
//                     <div className="dark-mode-toggle">
//                       <div className="toggle-buttons-dark">
//                         <button
//                           className={`toggle-btn-dark ${activeMode === 'active-id' ? 'active' : ''}`}
//                           onClick={() => handleModeChange('active-id')}
//                         >
//                           <CheckCircle size={20} className="me-3" />
//                           <div className="toggle-content">
//                             <div className="toggle-title">Active ID Transfer</div>
//                             <div className="toggle-subtitle">Fixed $5 amount</div>
//                           </div>
//                         </button>
//                         <button
//                           className={`toggle-btn-dark ${activeMode === 'send-money' ? 'active' : ''}`}
//                           onClick={() => handleModeChange('send-money')}
//                         >
//                           <Send size={20} className="me-3" />
//                           <div className="toggle-content">
//                             <div className="toggle-title">Send Money</div>
//                             <div className="toggle-subtitle">Custom amount</div>
//                           </div>
//                         </button>
//                       </div>
//                     </div>

//                     {/* Form Section */}
//                     <div className="dark-form-section">
//                       <form onSubmit={handleSubmit}>
//                         {/* Email Search */}
//                         <div className="form-group-dark">
//                           <label className="form-label-dark">
//                             <Search size={18} className="me-2" />
//                             Search Recipient by Email
//                           </label>
//                           <div className="search-container-dark">
//                             <div className="input-group-dark">
//                               <div className="input-icon-dark">
//                                 <User size={18} />
//                               </div>
//                               <input
//                                 type="email"
//                                 className="dark-input"
//                                 placeholder="Enter recipient's email address"
//                                 value={activeMode === 'active-id' ? activeEmail : sendEmail}
//                                 onChange={(e) => {
//                                   if (activeMode === 'active-id') {
//                                     setActiveEmail(e.target.value);
//                                   } else {
//                                     setSendEmail(e.target.value);
//                                   }
//                                   setSearchResult(null);
//                                   setAccountName('');
//                                   setApiError('');
//                                 }}
//                                 required
//                               />
//                               <button
//                                 type="button"
//                                 className="copy-btn-dark"
//                                 onClick={handleCopyEmail}
//                                 disabled={!activeEmail && !sendEmail}
//                               >
//                                 <Copy size={16} />
//                               </button>
//                             </div>
//                             <button
//                               type="button"
//                               className="search-btn-dark"
//                               onClick={activeMode === 'active-id' ? handleSearchActiveEmail : handleSearchSendEmail}
//                               disabled={searching}
//                             >
//                               {searching ? (
//                                 <>
//                                   <span className="spinner-border spinner-border-sm me-2"></span>
//                                   Searching...
//                                 </>
//                               ) : (
//                                 <>
//                                   <Search size={16} className="me-2" />
//                                   Search
//                                 </>
//                               )}
//                             </button>
//                           </div>
//                           {apiError && (
//                             <div className="error-message-dark mt-2">
//                               {apiError}
//                             </div>
//                           )}
//                         </div>

//                         {/* Search Result */}
//                         {searchResult && (
//                           <div className="search-result-dark">
//                             <div className="account-name-display-dark">
//                               <div className="account-name-label">Account Name :</div>
//                               <div className="account-name-value">{accountName}</div>
//                             </div>
//                           </div>
//                         )}

//                         {/* Amount Section */}
//                         <div className="amount-section-dark">
//                           {activeMode === 'active-id' ? (
//                             <div className="fixed-amount-dark">
//                               <div className="fixed-amount-label">Fixed Transfer Amount</div>
//                               <div className="fixed-amount-value">$5.00</div>
//                               <div className="fixed-amount-note">Active ID transfer amount (Fixed)</div>
//                             </div>
//                           ) : (
//                             <div className="custom-amount-dark">
//                               <label className="custom-amount-label">Enter Amount to Transfer</label>
//                               <div className="amount-input-container">
//                                 <div className="amount-input-group-dark">
//                                   <span className="currency-symbol-dark">$</span>
//                                   <input
//                                     type="number"
//                                     className="amount-input-dark"
//                                     placeholder="0.00"
//                                     min="1"
//                                     max={availableAmount}
//                                     step="0.01"
//                                     value={customAmount}
//                                     onChange={(e) => setCustomAmount(e.target.value)}
//                                     required
//                                     disabled={!searchResult}
//                                   />
//                                   <span className="currency-label-dark">USD</span>
//                                 </div>
//                                 <div className="amount-limits-dark">
//                                   <span>Min: $1.00</span>
//                                   <span>Available: ${availableAmount.toFixed(2)}</span>
//                                   <span>Max: ${availableAmount.toFixed(2)}</span>
//                                 </div>
//                               </div>
//                             </div>
//                           )}
//                         </div>

//                         {/* Submit Button */}
//                         <div className="submit-section">
//                           <button 
//                             type="submit" 
//                             className="submit-btn-dark"
//                             disabled={!searchResult || (activeMode === 'send-money' && !customAmount) || transferring}
//                           >
//                             {transferring ? (
//                               <>
//                                 <span className="spinner-border spinner-border-sm me-2"></span>
//                                 Processing...
//                               </>
//                             ) : (
//                               <>
//                                 <Send size={22} className="me-3" />
//                                 {activeMode === 'active-id' ? 'Transfer $5.00' : `Send $${customAmount || '0.00'}`}
//                               </>
//                             )}
//                           </button>
//                         </div>

//                         {/* Features */}
//                         <div className="features-section">
//                           <div className="row">
//                             <div className="col-md-4 mb-3">
//                               <div className="feature-item">
//                                 <div className="feature-icon secure-feature">
//                                   <Shield size={20} />
//                                 </div>
//                                 <div className="feature-content">
//                                   <div className="feature-title">Secure</div>
//                                   <div className="feature-desc">End-to-end encrypted</div>
//                                 </div>
//                               </div>
//                             </div>
//                             <div className="col-md-4 mb-3">
//                               <div className="feature-item">
//                                 <div className="feature-icon fast-feature">
//                                   <Zap size={20} />
//                                 </div>
//                                 <div className="feature-content">
//                                   <div className="feature-title">Instant</div>
//                                   <div className="feature-desc">Processed in seconds</div>
//                                 </div>
//                               </div>
//                             </div>
//                             <div className="col-md-4 mb-3">
//                               <div className="feature-item">
//                                 <div className="feature-icon low-feature">
//                                   <DollarSign size={20} />
//                                 </div>
//                                 <div className="feature-content">
//                                   <div className="feature-title">Low Fees</div>
//                                   <div className="feature-desc">Minimum charges</div>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </form>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Footer */}
//         <footer className="footer-dark">
//           <div className="container">
//             <p className="text-center mb-0">
//               Copyright © 2025 Willow Quantum. All rights reserved.
//             </p>
//           </div>
//         </footer>
//       </div>
//     </div>
//   );
// };

// export default WalletTransfer;

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../Core/Sidebar';
import Navbar from '../Core/Navbar';
import { Search, User, CheckCircle, Wallet, Send, Copy, ArrowLeft, Shield, Zap, DollarSign } from 'lucide-react';
import '../../Dashboard Style/WalletTransfer.css';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify'; // Import toast

const WalletTransfer = () => {
  const navigate = useNavigate();
  const [activeMode, setActiveMode] = useState('active-id'); // 'active-id' or 'send-money'
  const [availableAmount] = useState(1500.75); // Main wallet amount
  const [activeEmail, setActiveEmail] = useState('');
  const [sendEmail, setSendEmail] = useState('');
  const [customAmount, setCustomAmount] = useState('');
  const [searching, setSearching] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [searchResult, setSearchResult] = useState(null);
  const [accountName, setAccountName] = useState('');
  const [apiError, setApiError] = useState('');
  const [transferring, setTransferring] = useState(false);
  const authToken = useSelector((state) => state.user?.token);

  // Add openDropdowns state
  const [openDropdowns, setOpenDropdowns] = useState({});

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Initialize sidebar functionality (same as in Dashboard)
  useEffect(() => {
    const sidebar = document.querySelector('.sidebar');
    const sidebarBody = document.querySelector('.sidebar-body');
    
    if (sidebar) {
      if (sidebarOpen) {
        sidebar.classList.remove('close');
      } else {
        sidebar.classList.add('close');
      }
    }
    
    // Add custom scrollbar to sidebar body
    if (sidebarBody) {
      sidebarBody.style.height = 'calc(100vh - 70px)';
      sidebarBody.style.overflowY = 'auto';
    }

    // Initialize dropdowns as closed
    const initialDropdownState = {
      dashboard: false,
      fundManagement: false,
      registrationTeam: false,
      incomeEarnings: false,
      bonanzaRewards: false,
      airdrop: false,
      withdrawal: false,
      settings: false
    };
    setOpenDropdowns(initialDropdownState);

    return () => {
      // Cleanup
    };
  }, [sidebarOpen]);

  useEffect(() => {
    // Add custom scrollbar styles for sidebar
    const style = document.createElement('style');
    style.innerHTML = `
      /* Custom scrollbar for sidebar */
      .sidebar-body {
        height: calc(100vh - 70px);
        overflow-y: auto;
      }
      
      .sidebar-body::-webkit-scrollbar {
        width: 6px;
      }
      
      .sidebar-body::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.3);
      }
      
      /* Sidebar dropdown menu styles */
      .sidebar .nav-dropdown {
        list-style: none;
        padding-left: 0;
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease;
      }
      
      .sidebar .nav-dropdown.show {
        max-height: 500px;
      }
      
      .sidebar .nav-dropdown-item {
        padding-left: 2.5rem;
      }
      
      /* Sidebar dropdown toggle with icon */
      .nav-item.has-dropdown .nav-link {
        position: relative;
        padding-right: 2.5rem;
      }
      
      .nav-item.has-dropdown .dropdown-icon {
        position: absolute;
        right: 1rem;
        top: 50%;
        transform: translateY(-50%);
        transition: transform 0.3s ease;
      }
      
      .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
        transform: translateY(-50%) rotate(180deg);
      }
      
      /* Improved dropdown styling similar to first image */
      .nav-item.has-dropdown .nav-dropdown {
        background: rgba(255, 255, 255, 0.05);
        border-left: 3px solid var(--primary-color, #0d6efd);
        margin-left: 1rem;
        border-radius: 0 0 8px 8px;
      }
      
      .nav-item.has-dropdown .nav-dropdown-item .nav-link {
        padding: 0.75rem 1rem 0.75rem 2rem;
        color: rgba(255, 255, 255, 0.8);
      }
      
      .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
        background: rgba(255, 255, 255, 0.1);
        color: white;
      }
      
      /* Fix for category text styling */
      .nav-item.has-dropdown .link-title.nav-item.nav-category {
        font-weight: 600;
        font-size: 0.875rem;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
      
      /* Smooth transitions */
      .sidebar {
        transition: all 0.3s ease;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Toggle dropdown function (for the Sidebar component)
  const toggleDropdown = (key) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // API call to search user by email
  const searchUserByEmail = async (email) => {
    try {
      setSearching(true);
      setApiError('');
      
      const response = await fetch(`https://admin.oceaniabloom9.com/api/user/get-user-by-email`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Accept': 'application/json',
        },
        body: new URLSearchParams({
          email: email
        })
      });

      const data = await response.json();
      
      if (data.status) {
        // User found successfully
        setAccountName(data.data.account_name || 'User Found');
        setSearchResult({
          email: email,
          name: data.data.account_name || email,
          avatarColor: '#00d4aa',
          verified: true
        });
        toast.success('User found successfully!');
        return { success: true, data: data.data };
      } else {
        // User not found or error
        setSearchResult(null);
        setAccountName('');
        setApiError(data.message || 'User not found');
        toast.error(data.message || 'User not found');
        return { success: false, message: data.message };
      }
    } catch (error) {
      console.error('Error searching user:', error);
      setSearchResult(null);
      setAccountName('');
      setApiError('Failed to search user. Please try again.');
      toast.error('Failed to search user. Please try again.');
      return { success: false, message: 'Network error' };
    } finally {
      setSearching(false);
    }
  };

  const handleSearchActiveEmail = async () => {
    if (!activeEmail.trim()) {
      toast.error('Please enter an email address');
      return;
    }
    
    await searchUserByEmail(activeEmail);
  };

  const handleSearchSendEmail = async () => {
    if (!sendEmail.trim()) {
      toast.error('Please enter an email address');
      return;
    }
    
    await searchUserByEmail(sendEmail);
  };

  // API call for Active ID transfer ($5)
  const handleActiveIdTransfer = async () => {
    try {
      setTransferring(true);
      
      const response = await fetch(`https://admin.oceaniabloom9.com/api/user/active-register-user-by-wallet`, {
        method: 'POST',
         headers: {
          'Authorization': `Bearer ${authToken}`,
          'Accept': 'application/json',
        },
        body: new URLSearchParams({
          email: activeEmail
        })
      });

      const data = await response.json();
      
      if (data.status) {
        toast.success('User activated successfully! $5 transferred.');
        navigate('/dashboard');
      } else {
        toast.error(data.message || 'Transfer failed');
      }
    } catch (error) {
      console.error('Error activating user:', error);
      toast.error('Failed to activate user. Please try again.');
    } finally {
      setTransferring(false);
    }
  };

  // API call for Send Money transfer (custom amount)
  const handleSendMoneyTransfer = async () => {
    try {
      setTransferring(true);
      
      const response = await fetch(`https://admin.oceaniabloom9.com/api/user/sent-wallet`, {
        method: 'POST',
         headers: {
          'Authorization': `Bearer ${authToken}`,
          'Accept': 'application/json',
        },
        body: new URLSearchParams({
          email: sendEmail,
          wallet_type: 'FuelWallet', // Adjust this based on your requirements
          amount: customAmount
        })
      });

      const data = await response.json();
      
      if (data.status) {
        toast.success(`$${customAmount} sent successfully!`);
        navigate('/dashboard');
      } else {
        toast.error(data.message || 'Transfer failed');
      }
    } catch (error) {
      console.error('Error sending money:', error);
      toast.error('Failed to send money. Please try again.');
    } finally {
      setTransferring(false);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
    
  //   if (activeMode === 'active-id') {
  //     if (!activeEmail.trim()) {
  //       toast.error('Please enter recipient email');
  //       return;
  //     }
      
  //     if (!searchResult) {
  //       toast.error('Please search and verify the user first');
  //       return;
  //     }
      
  //     // Replace window.confirm with toast confirmation
  //     toast.info(
  //       <div>
  //         <p>Send $5.00 to {activeEmail}?</p>
  //         <div className="d-flex justify-content-center gap-2 mt-2">
  //           <button 
  //             className="btn btn-sm btn-success"
  //             onClick={async () => {
  //               await handleActiveIdTransfer();
  //               toast.dismiss();
  //             }}
  //           >
  //             Confirm
  //           </button>
  //           <button 
  //             className="btn btn-sm btn-secondary"
  //             onClick={() => toast.dismiss()}
  //           >
  //             Cancel
  //           </button>
  //         </div>
  //       </div>,
  //       {
  //         autoClose: false,
  //         closeButton: false,
  //         closeOnClick: false,
  //       }
  //     );
  //   } else {
  //     if (!sendEmail.trim() || !customAmount) {
  //       toast.error('Please fill all fields');
  //       return;
  //     }
      
  //     if (!searchResult) {
  //       toast.error('Please search and verify the user first');
  //       return;
  //     }
      
  //     const amount = parseFloat(customAmount);
  //     if (amount > availableAmount) {
  //       toast.error('Insufficient funds in your wallet');
  //       return;
  //     }
      
  //     if (amount < 1) {
  //       toast.error('Minimum transfer amount is $1');
  //       return;
  //     }
      
  //     // Replace window.confirm with toast confirmation
  //     toast.info(
  //       <div>
  //         <p>Send ${amount.toFixed(2)} to {sendEmail}?</p>
  //         <div className="d-flex justify-content-center gap-2 mt-2">
  //           <button 
  //             className="btn btn-sm btn-success"
  //             onClick={async () => {
  //               await handleSendMoneyTransfer();
  //               toast.dismiss();
  //             }}
  //           >
  //             Confirm
  //           </button>
  //           <button 
  //             className="btn btn-sm btn-secondary"
  //             onClick={() => toast.dismiss()}
  //           >
  //             Cancel
  //           </button>
  //         </div>
  //       </div>,
  //       {
  //         autoClose: false,
  //         closeButton: false,
  //         closeOnClick: false,
  //       }
  //     );
  //   }
  // };

  const handleSubmit = async (e) => {
  e.preventDefault();
  
  if (activeMode === 'active-id') {
    if (!activeEmail.trim()) {
      toast.error('Please enter recipient email');
      return;
    }
    
    if (!searchResult) {
      toast.error('Please search and verify the user first');
      return;
    }
    
    // Direct API call without confirmation dialog
    await handleActiveIdTransfer();
    
  } else {
    if (!sendEmail.trim() || !customAmount) {
      toast.error('Please fill all fields');
      return;
    }
    
    if (!searchResult) {
      toast.error('Please search and verify the user first');
      return;
    }
    
    const amount = parseFloat(customAmount);
    if (amount > availableAmount) {
      toast.error('Insufficient funds in your wallet');
      return;
    }
    
    if (amount < 1) {
      toast.error('Minimum transfer amount is $1');
      return;
    }
    
    // Direct API call without confirmation dialog
    await handleSendMoneyTransfer();
  }
};

  const handleCopyEmail = () => {
    const email = activeMode === 'active-id' ? activeEmail : sendEmail;
    if (email) {
      navigator.clipboard.writeText(email);
      toast.success('Email copied to clipboard!');
    }
  };

  // Reset search when switching modes
  const handleModeChange = (mode) => {
    setActiveMode(mode);
    setSearchResult(null);
    setAccountName('');
    setApiError('');
    if (mode === 'active-id') {
      setSendEmail('');
    } else {
      setActiveEmail('');
    }
  };

  return (
    <div className="main-wrapper dark-theme">
      {/* Sidebar */}
      <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
        <div className="sidebar-header">
          <a href="#" className="sidebar-brand">
            <i className="me-2" data-lucide="atom"></i>
            Willow <span>Quantum</span>
          </a>
          <div className="sidebar-toggler" onClick={toggleSidebar}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <Sidebar />
      </nav>

      <div className="page-wrapper">
        {/* Navbar */}
        <Navbar toggleSidebar={toggleSidebar} />

        {/* Main Content */}
        <div className="page-content">
          <div className="wallet-transfer-container-dark">
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="" style={{width:"100%"}}>
                  {/* Main Card */}
                  <div className="dark-transfer-card">
                 
                    <div className="dark-balance-section">
                      <div className="balance-card-dark">
                        <div className="balance-content">
                          <div className="balance-label-dark">My Wallet Balance</div>
                          <div className="balance-amount-dark">${availableAmount.toFixed(2)}</div>
                          <div className="balance-subtitle-dark">Quantum Main Vault • Ready to Transfer</div>
                        </div>
                        <div className="wallet-icon-dark">
                          <Wallet size={40} />
                        </div>
                      </div>
                    </div>

                    {/* Mode Toggle */}
                    <div className="dark-mode-toggle">
                      <div className="toggle-buttons-dark">
                        <button
                          className={`toggle-btn-dark ${activeMode === 'active-id' ? 'active' : ''}`}
                          onClick={() => handleModeChange('active-id')}
                        >
                          <CheckCircle size={20} className="me-3" />
                          <div className="toggle-content">
                            <div className="toggle-title">Active ID Transfer</div>
                            <div className="toggle-subtitle">Fixed $5 amount</div>
                          </div>
                        </button>
                        <button
                          className={`toggle-btn-dark ${activeMode === 'send-money' ? 'active' : ''}`}
                          onClick={() => handleModeChange('send-money')}
                        >
                          <Send size={20} className="me-3" />
                          <div className="toggle-content">
                            <div className="toggle-title">Send Money</div>
                            <div className="toggle-subtitle">Custom amount</div>
                          </div>
                        </button>
                      </div>
                    </div>

                    {/* Form Section */}
                    <div className="dark-form-section">
                      <form onSubmit={handleSubmit}>
                        {/* Email Search */}
                        <div className="form-group-dark">
                          <label className="form-label-dark">
                            <Search size={18} className="me-2" />
                            Search Recipient by Email
                          </label>
                          <div className="search-container-dark">
                            <div className="input-group-dark">
                              <div className="input-icon-dark">
                                <User size={18} />
                              </div>
                              <input
                                type="email"
                                className="dark-input"
                                placeholder="Enter recipient's email address"
                                value={activeMode === 'active-id' ? activeEmail : sendEmail}
                                onChange={(e) => {
                                  if (activeMode === 'active-id') {
                                    setActiveEmail(e.target.value);
                                  } else {
                                    setSendEmail(e.target.value);
                                  }
                                  setSearchResult(null);
                                  setAccountName('');
                                  setApiError('');
                                }}
                                required
                              />
                              <button
                                type="button"
                                className="copy-btn-dark"
                                onClick={handleCopyEmail}
                                disabled={!activeEmail && !sendEmail}
                              >
                                <Copy size={16} />
                              </button>
                            </div>
                            <button
                              type="button"
                              className="search-btn-dark"
                              onClick={activeMode === 'active-id' ? handleSearchActiveEmail : handleSearchSendEmail}
                              disabled={searching}
                            >
                              {searching ? (
                                <>
                                  <span className="spinner-border spinner-border-sm me-2"></span>
                                  Searching...
                                </>
                              ) : (
                                <>
                                  <Search size={16} className="me-2" />
                                  Search
                                </>
                              )}
                            </button>
                          </div>
                          {apiError && (
                            <div className="error-message-dark mt-2">
                              {apiError}
                            </div>
                          )}
                        </div>

                        {/* Search Result */}
                        {searchResult && (
                          <div className="search-result-dark">
                            <div className="account-name-display-dark">
                              <div className="account-name-label">Account Name :</div>
                              <div className="account-name-value">{accountName}</div>
                            </div>
                          </div>
                        )}

                        {/* Amount Section */}
                        <div className="amount-section-dark">
                          {activeMode === 'active-id' ? (
                            <div className="fixed-amount-dark">
                              <div className="fixed-amount-label">Fixed Transfer Amount</div>
                              <div className="fixed-amount-value">$5.00</div>
                              <div className="fixed-amount-note">Active ID transfer amount (Fixed)</div>
                            </div>
                          ) : (
                            <div className="custom-amount-dark">
                              <label className="custom-amount-label">Enter Amount to Transfer</label>
                              <div className="amount-input-container">
                                <div className="amount-input-group-dark">
                                  <span className="currency-symbol-dark">$</span>
                                  <input
                                    type="number"
                                    className="amount-input-dark"
                                    placeholder="0.00"
                                    min="1"
                                    max={availableAmount}
                                    step="0.01"
                                    value={customAmount}
                                    onChange={(e) => setCustomAmount(e.target.value)}
                                    required
                                    disabled={!searchResult}
                                  />
                                  <span className="currency-label-dark">USD</span>
                                </div>
                                <div className="amount-limits-dark">
                                  <span>Min: $1.00</span>
                                  <span>Available: ${availableAmount.toFixed(2)}</span>
                                  <span>Max: ${availableAmount.toFixed(2)}</span>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Submit Button */}
                        <div className="submit-section">
                          <button 
                            type="submit" 
                            className="submit-btn-dark"
                            disabled={!searchResult || (activeMode === 'send-money' && !customAmount) || transferring}
                          >
                            {transferring ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2"></span>
                                Processing...
                              </>
                            ) : (
                              <>
                                <Send size={22} className="me-3" />
                                {activeMode === 'active-id' ? 'Transfer $5.00' : `Send $${customAmount || '0.00'}`}
                              </>
                            )}
                          </button>
                        </div>

                        {/* Features */}
                        <div className="features-section">
                          <div className="row">
                            <div className="col-md-4 mb-3">
                              <div className="feature-item">
                                <div className="feature-icon secure-feature">
                                  <Shield size={20} />
                                </div>
                                <div className="feature-content">
                                  <div className="feature-title">Secure</div>
                                  <div className="feature-desc">End-to-end encrypted</div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <div className="feature-item">
                                <div className="feature-icon fast-feature">
                                  <Zap size={20} />
                                </div>
                                <div className="feature-content">
                                  <div className="feature-title">Instant</div>
                                  <div className="feature-desc">Processed in seconds</div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <div className="feature-item">
                                <div className="feature-icon low-feature">
                                  <DollarSign size={20} />
                                </div>
                                <div className="feature-content">
                                  <div className="feature-title">Low Fees</div>
                                  <div className="feature-desc">Minimum charges</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="footer-dark">
          <div className="container">
            <p className="text-center mb-0">
              Copyright © 2025 Willow Quantum. All rights reserved.
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default WalletTransfer;